import { ReactNode } from 'react';
import { TextVariant } from './types';

export const COMMON_MODAL_CONSTANTS: Record<string, TextVariant> = {
  checkTicket: { common: '참가권 획득 후 클릭해주세요!' },
  isAgreePrivacy: {
    common: (
      <>
        개인정보 3자 제공
        <br />
        동의 여부를 선택해주세요.
      </>
    ),
  },
  realNotAgreeText: {
    common: (
      <>
        동의하지 않을경우 <br />
        참가권을 획득했어도 토너먼트
        <br />
        참여가 불가능합니다.
      </>
    ),
  },
  checkAgree: {
    common: (
      <>
        개인정보 3자 제공
        <br />
        동의 여부를 선택해주세요.
      </>
    ),
  },
  completeAgree: {
    common: (
      <>
        개인정보 3자 제공
        <br /> 동의가 완료 되었습니다.
      </>
    ),
  },
  realAgreeText: { common: '정말 미동의 하시겠습니까?' },
  checkTournamentText: { common: '토너먼트 진행 내용을 확인해주세요!' },
  notAgreeBtn: { common: '미동의' },
  reSelectBtn: { common: '다시 선택' },
  confirmBtn: { common: '확인' },
};

export const getNotStartText = (formattedDate: string): ReactNode => (
  <>
    {formattedDate} 새틀라이트가
    <br /> 시작되면 확인이 가능합니다!
  </>
);
